import { render, staticRenderFns } from "./resumen.vue?vue&type=template&id=f73d2930&scoped=true&"
import script from "./resumen.vue?vue&type=script&lang=js&"
export * from "./resumen.vue?vue&type=script&lang=js&"
import style0 from "./resumen.vue?vue&type=style&index=0&id=f73d2930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73d2930",
  null
  
)

export default component.exports